import NewOperatorForm from './NewOperatorForm';
import type { Operator } from '@/data/operator';
import { $currentOperator, $operators } from '@/stores';
import { closeDialog } from '@/stores/dialog';
import { logs } from '@/stores/logbook';
import { timeNow } from '@/utils/clock';
import { useStore } from '@nanostores/react';
import { useCallback, useState } from 'react';

export function ChangeOperatorDialog() {
  const operators = useStore($operators);
  const [showNewOperatorForm, setShowNewOperatorForm] = useState(false);

  const onChange = useCallback((operator: Operator) => {
    const oldOperator = $currentOperator.get();
    if (oldOperator && oldOperator.id === operator.id) {
      closeDialog();
      return;
    }
    $currentOperator.set(operator);
    logs.addLog({
      id: `log-${Date.now()}`,
      type: 'radioShift',
      draft: false,
      entries: [
        {
          timestamp: Date.now(),
          oldOperator,
          newOperator: operator,
          notes: `Changed operator to ${operator.name}`,
          time: timeNow(),
        },
      ],
    });
    closeDialog();
  }, []);

  return (
    <div className="stop-scrolling fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="flex w-80 flex-col gap-4 rounded-lg bg-white p-6 shadow-lg">
        <h2 className="mb-4 text-xl font-bold text-gray-800">
          Change Operator
        </h2>
        <div className="flex max-h-64 flex-row flex-wrap gap-4 overflow-y-auto">
          {operators.map(op => (
            <button
              key={op.id}
              className="rounded bg-gray-100 px-4 py-2 text-sm font-medium text-gray-700 shadow-md hover:bg-gray-200 focus:ring-2 focus:ring-blue-400 focus:outline-none"
              onClick={() => onChange(op)}
            >
              {op.name}
            </button>
          ))}
        </div>
        <button
          onClick={() => setShowNewOperatorForm(!showNewOperatorForm)}
          className="mt-4 flex items-center justify-center gap-2 rounded bg-blue-500 px-4 py-2 text-sm font-medium text-white shadow-md hover:bg-blue-600 focus:ring-2 focus:ring-blue-400 focus:outline-none"
        >
          {showNewOperatorForm ? 'Cancel' : 'New Operator'}
        </button>
        {showNewOperatorForm && (
          <NewOperatorForm
            onAdd={newOp => {
              $operators.set([...$operators.get(), newOp]);
              setShowNewOperatorForm(false);
            }}
          />
        )}
      </div>
    </div>
  );
}
